import classNames from "classnames";
import React, { useEffect, useState } from "react";

import { ProductTileModel } from "@api/mappers/products.mapper";

import { useBreakpoint } from "@utils/breakpoints/breakpoints.provider";
import { ProductSliderSources } from "@utils/enums";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { InfoBlockHeading } from "../productInfo/infoBlockHeading/infoBlockHeading.component";
import { ProductPageConfig } from "../productPage.config";
import { RelatedProductsSliderComponent } from "./relatedProductsSlider.component";

type RelatedProductsSliderProps = {
    productSource: ProductSliderSources;
    prefetchedData?: Array<ProductTileModel>;
};

const RelatedProductsSlider = ({
    productSource,
    prefetchedData,
}: RelatedProductsSliderProps) => {
    const { breakpoints } = useBreakpoint();
    const [showMobileMore, setShowMobileMore] = useState(false);
    const { t } = useGranite();

    const title =
        productSource === ProductSliderSources.mainProduct
            ? t("sliders.mainProducts.title")
            : productSource === ProductSliderSources.accessory
            ? t("sliders.accessories.title")
            : "";

    const breakpointLayoutSettings = JSON.stringify(
        ProductPageConfig.sliders.relatedProducts,
    );

    useEffect(() => {
        setShowMobileMore(!!breakpoints?.lg);
    }, [breakpoints?.lg]);

    return (
        <section
            id={"related-products-slider"}
            className={classNames(
                `related-products-slider info-block js-info-block js-anchor-scroll-spy__block`,
                showMobileMore ? "info-block--active" : "",
            )}
        >
            <InfoBlockHeading
                title={title}
                onClick={() => setShowMobileMore(state => !state)}
            />
            <RelatedProductsSliderComponent
                prefetchedData={prefetchedData}
                productSource={productSource}
                title={!!breakpoints.lg ? title : ""}
                breakpointsLayoutSettings={breakpointLayoutSettings}
            />
        </section>
    );
};

export { RelatedProductsSlider };
